var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"list-title",attrs:{"color":_vm.color,"dark":_vm.dark}},[_c('v-toolbar-title',[_vm._t("title")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }